<div class="container">
  <mat-card class="declined-card decline-text">
    <p>
      Thank you for your consideration and please enjoy your stay!
    </p>
  </mat-card>
</div>



